import { createContext, useContext } from 'react'
import type { RuntimeLocalization } from './localization'

const FALLBACK: RuntimeLocalization = {
	locale: 'en',
	default_locale: 'en',
	supported_locales: ['en'],
	direction: 'ltr',
	messages: {},
	resources: {},
}

export const LocalizationContext = createContext<RuntimeLocalization>(FALLBACK)

export function useRuntimeLocalization(): RuntimeLocalization {
	return useContext(LocalizationContext)
}
